<template>
  <div class="panel-wrapper">
    <div class="panel">
      <button
        class="btn btn-action"
        @click="CopyMoveReportModalAction = 'copy'"
        title="Копирай планираното за повече дни"
      >
        <img src="../../assets/img/plan_copy.svg" alt="Копирай" />
      </button>
      <button
        class="btn btn-action"
        @click="CopyMoveReportModalAction = 'move'"
        title="Премести отчета за друг ден"
      >
        <img src="../../assets/img/plan_move.svg" alt="Премести" />
      </button>
      <button class="btn btn-action" @click="deleteReport()" title="Изтрий отчета">
        <img src="../../assets/img/plan_delete.svg" alt="Изтрий" />
      </button>
      <button class="btn btn-convert" @click="convert()">
        <span class="mck2">k</span>
        Създай отчет на база планираното
      </button>
    </div>
    <transition name="fade">
      <CopyMoveReportModal
        v-if="CopyMoveReportModalAction"
        :action="CopyMoveReportModalAction"
        :id="report._id"
        :initialDate="report.date"
        @closeCopyMoveReportModal="closeCopyMoveReportModal"
      />
    </transition>
  </div>
</template>

<script>
import CopyMoveReportModal from '../shared/CopyMoveReportModal';
export default {
  components: {
    CopyMoveReportModal
  },
  props: ['report'],
  data() {
    return {
      CopyMoveReportModalAction: ''
    };
  },
  methods: {
    closeCopyMoveReportModal(e) {
      if (this.CopyMoveReportModalAction === 'move' && e.updated) {
        this.$emit('get-report-moved');
      }
      this.CopyMoveReportModalAction = '';
    },
    deleteReport() {
      const msg = 'Сигурни ли сте, че искате да изтриете планирането?';

      if (confirm(msg)) {
        let url = `${process.env.VUE_APP_BASE_URI}/report/${this.report._id}`;
        this.$http
          .delete(url)
          .then(() => {
            this.$snotify.success('Планирането е изтрито успешно!');
            this.$router.push('/reports/own');
          })
          .catch(error => {
            this.$snotify.error('Нещо се обърка!');
            console.log(error);
          });
      }
    },
    convert() {
      const today = new Date();
      today.setHours(23, 59, 59, 999);

      if (today.getTime() < this.report.date.getTime()) {
        this.$snotify.error('Не можете да създавате отчети с бъдеща дата!');
        return;
      }

      const msg =
        'Сигурни ли сте, че искате да конвертирате планирането в отчет?';

      if (confirm(msg)) {
        let url = `${process.env.VUE_APP_BASE_URI}/report/convert`;
        this.$http
          .post(url, { _id: this.report._id })
          .then(() => {
            this.$snotify.success('Планирането е успешно конвертирано в отчет');
            this.$emit('get-report');
          })
          .catch(error => {
            this.$snotify.error('Нещо се обърка!');
            console.log(error);
          });
      }
    }
  }
};
</script>

<style scoped>
.panel-wrapper {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  width: 100%;
}
.panel {
  background-color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0px 0px 99px #00000087;
  display: flex;
  padding: 20px 40px;
}
.btn-action {
  background-color: #ebebeb;
  width: 40px;
}
.btn-action:hover {
  background-color: #f3f3f3;
}
.btn-action:first-child {
  margin: 0;
}
.btn-convert {
  background-color: var(--color-main);
  padding: 0 20px;
  width: initial;
}
.btn-convert:hover {
  background-color: #ff710b;
}
</style>